<div class="wrapper">
  <button class="action-button hinted" [ngClass]="{'btn-block': full}" (mouseover)="showInfo()" (click)="downloadDocument()" [disabled]="disabled">
    <i class="fa fa-eye" *ngIf="!(visible && !tooltip?.instance?.loading && tooltip?.instance?.isPdfFile() === true && tooltip?.instance?.hasPreview() === true)"></i>
    <i class="fa fa-eye-slash" *ngIf="visible && !tooltip?.instance?.loading && tooltip?.instance?.isPdfFile() === true && tooltip?.instance?.hasPreview() === true"></i>
    <div class="hint">File Preview</div>
  </button>

  <template #target></template>
</div>
